import { GenericFilter } from '@/components/GenericFilter';
import type { ListUserFilterType, ListUserFilterTypeWithValues } from '@shelflix/schemas/user/list';
import type { ListRoleOutputDto } from '@shelflix/trpc/routes/role/list/useCase';

export function UserFilter({
  onChange,
  roles,
}: {
  onChange: (filters: ListUserFilterTypeWithValues) => void;
  roles: ListRoleOutputDto;
}) {
  const options: ListUserFilterType = {
    search: {
      label: 'Nome ou email',
      fields: ['name', 'email'],
    },
    filter: [
      {
        label: 'Status',
        field: { name: 'active', condition: 'equals' },
        items: [
          { text: 'Ativo', value: true },
          { text: 'Inativo', value: false },
        ],
      },
      {
        label: 'Cargo',
        field: { name: 'role', condition: 'equals' },
        items: roles.map((role) => ({ text: role.name, value: role.uuid })),
      },
    ],
    sort: {
      label: 'Ordenar por acesso',
      options: [
        { field: 'lastLoginAt', direction: 'asc', text: 'Mais antigo' },
        { field: 'lastLoginAt', direction: 'desc', text: 'Mais recente' },
      ],
    },
  };

  return <GenericFilter options={options} onChange={onChange} />;
}
